const confirmDeleteWord = "DELETE";

export const en = {
  sites: "Sites",
  settings: "Settings",
  save: "Save",
  add: "Add",
  edit: "Edit",
  new: "New",
  delete: "Delete",
  "create a new site": "Create a new site",
  name: "Name",
  dashboard: "Dashboard",
  cancel: "Cancel",
  back: "Back",
  signUp: "Sign Up",
  signIn: "Sign In",
  "Sign Out": "Sign Out",
  "Your email": "Your email",
  username: "Username",
  password: "Password",
  language: "Language",
  color: "Color",
  "is available": "is available",
  "is already taken": "is already taken",
  title: "Title",
  description: "Description",
  button: "Button",
  introduction: "Introduction",
  "Main button": "Main Button",
  "External link button": "External link button",
  "Add an optional button that opens another website in a new tab.":
    "Add an optional button that opens another website in a new tab.",
  "Show external link button": "Show external link button",
  "Button text": "Button text",
  "External URL": "External URL",
  link: "Link",
  "Site updated": "Site updated",
  "Contact us": "Contact Us",
  "Still have questions? Get in touch.": "Still have questions? Get in touch.",
  logo: "Logo",
  designer: "Designer",
  contactForm: "Contact form",
  "Your settings have been updated": "Your settings have been updated",
  dangerZone: "Danger zone",
  "Book Appointment": "Book Online Appointment",
  "This action cannot be reverted or undone": [
    "This action cannot be reverted or undone.",
    "Once deleted, all data",
    "will be permanently removed and cannot be recovered",
  ].join(" "),
  "Are you sure?": "Are you sure?",
  "delete your account": "Delete your account",
  "Are you sure you want to delete this site? To confirm, type DELETE.": [
    `Are you sure you want to delete this site? To confirm, type "${confirmDeleteWord}".`,
    "This action cannot be reverted or undone.",
  ].join(" "),
  "Are you sure you want to delete your account? To confirm, type DELETE.": [
    `Are you sure you want to delete your account? To confirm, type "${confirmDeleteWord}".`,
    "This action cannot be reverted or undone.",
  ].join(" "),
  confirmDeleteWord,
  "Your account has been deleted": "Your account has been deleted.",
  "Already have an account?": "Already have an account?",
  "Don't have an account yet?": "Don't have an account yet?",
  "Forgotten password?": "Forgotten password?",
  "Something went wrong": "Oops... something went wrong!",
  "Our services": "Our services",
  general: "General",
  domains: "Domains",
  "Domain deleted": "Domain deleted",
  seo: "SEO",
  ai: "AI",
  billings: "Billings",
  seoDescriptionMessage: `Keywords describe your content and help search engines categorize it. However, because too many abuse them, search engines now prioritize how well your content answers users’ questions. Use keywords naturally, but don’t force them. Instead, focus on creating clear, relevant, and detailed content.`,
  Keyword: "Keyword",
  "Keywords describe your content and help search engines categorize it": [
    `Keywords describe your content and help search engines categorize it.`,
    `However, because too many abuse them, search engines now prioritize how`,
    `well your content answers users’ questions. Use keywords naturally, but`,
    `don’t force them. Instead, focus on creating clear, relevant, and`,
    `detailed content.`,
  ].join(" "),
  "A domain is the unique web address (e.g. yourwebsite.com) that people use to access your site.":
    "A domain is the unique web address (e.g. yourwebsite.com) that people use to access your site.",
  "Add both DNS records at your DNS provider. Choose CNAME as the record type.":
    "Add both DNS records at your DNS provider. Choose CNAME as the record type.",
  "Domain setup": "Domain setup",
  "DNS records": "DNS records",
  "DNS provider": "DNS provider",
  "Setup guide": "Setup guide",
  "If you encounter any difficulties, please contact us":
    "If you encounter any difficulties, please contact us",
  "CNAME doc links - OVH":
    "https://docs.ovhcloud.com/en/guides/web-cloud/domains/dns-zone-cname-record-creation",
  "CNAME doc links - Ionos":
    "https://www.ionos.com/help/domains/configuring-cname-records-for-subdomains/configuring-a-cname-record-for-a-subdomain/",
  "CNAME doc links - Cloudflare":
    "https://developers.cloudflare.com/dns/manage-dns-records/how-to/create-dns-records/",
  "CNAME doc links - GoDaddy":
    "https://www.godaddy.com/help/add-a-cname-record-19236",
  "CNAME doc links - Namecheap":
    "https://www.namecheap.com/support/knowledgebase/article.aspx/9646/2237/how-to-create-a-cname-record-for-your-domain/",
  "CNAME doc links - Squarespace":
    "https://support.squarespace.com/hc/en-us/articles/360002101888-Edit-your-domain-s-DNS-records",
  Team: "Team",
  "About Us": "About Us",
  Photo: "Photo",
  Text: "Text",
  FAQ: "FAQ",
  Question: "Question",
  Answer: "Answer",
  "Frequently asked questions": "Frequently asked questions",
  "Type your text here...": "Type your text here...",
  "Social links": "Social links",
  "Add social link": "Add social link",
  designerHeroTitlePlaceholder: "Acme Studio",
  designerHeroDescriptionPlaceholder:
    "We help local businesses bring their ideas to life.",
  designerButtonLabelPlaceholder: "Book a consultation",
  designerButtonUrlPlaceholder: "https://cal.com/your-business",
  designerServicesTitlePlaceholder: "What we do",
  designerServiceTitlePlaceholder: "Website design",
  designerServiceDescriptionPlaceholder:
    "A clear, tailored service designed around your needs.",
  designerTeamTitlePlaceholder: "Meet the team",
  designerTeamDescriptionPlaceholder:
    "A small team with the experience to move your project forward.",
  designerTeamMemberNamePlaceholder: "Marie Dupont",
  designerSocialUrlPlaceholder: "https://instagram.com/your-business",
  designerTextPlaceholder:
    "Share your story, values, or anything visitors should know.",
  designerFaqTitlePlaceholder: "Frequently asked questions",
  designerFaqQuestionPlaceholder: "How quickly can you start?",
  designerFaqAnswerPlaceholder: "Most projects start within two weeks.",
  designerContactTitlePlaceholder: "Let’s talk about your project",
  designerContactDescriptionPlaceholder:
    "Tell us what you need and we’ll get back to you soon.",
  designerHelpFor: "Help for",
  designerShowSection: "Show or hide section",
  designerColorHelp:
    "Choose the main color used for buttons, links, and highlights across your website. Select a shade that fits your brand and keeps text easy to read.",
  designerLogoHelp:
    "Upload the main image displayed at the top of your website. Use a clear, high-quality image that represents your business.",
  designerIntroductionHelp:
    "This is the first message visitors see. Use it to say who you are, what you do, and why they should keep reading.",
  designerExternalLinkHelp:
    "Add an optional button that sends visitors to another website, such as a booking page or online shop. Enter the complete web address.",
  designerServicesHelp:
    "Turn this section on to explain what you offer. Give the section a heading, then add one service and a short description per row.",
  designerPhotosHelp:
    "Turn this section on to create a photo gallery. Add clear images that show your work, space, products, or atmosphere.",
  designerTeamHelp:
    "Turn this section on to introduce the people behind your business. Add a heading, a short introduction, and each person’s photo, name, and social links.",
  designerTextHelp:
    "Turn this section on when you need an extra block of text, such as your story, values, process, or practical information.",
  designerFaqHelp:
    "Turn this section on to answer the questions visitors ask most often. Add one clear question and answer per row.",
  designerContactHelp:
    "Turn this section on to let visitors send you a message. The title and description appear directly above the contact form.",
  designerHeroTitleHelp:
    "The main heading at the top of your website. Usually use your business name or a short statement of what you do.",
  designerHeroDescriptionHelp:
    "A short introduction below the main heading. Explain what you offer and who it is for in one or two clear sentences.",
  designerButtonTextHelp:
    "The words visitors click, such as “Book a consultation”. Use a short action phrase.",
  designerButtonUrlHelp:
    "The page that opens when visitors click the button. Enter the complete address, for example https://example.com.",
  designerServicesTitleHelp:
    "The heading shown above all your services. Use a simple phrase that introduces what your business offers.",
  designerServiceTitleHelp:
    "The name of one service. Keep it short so visitors can scan your offers quickly.",
  designerServiceDescriptionHelp:
    "A short explanation of this service, including what the customer receives or how it helps them.",
  designerTeamTitleHelp:
    "The heading shown above your team, such as “Meet the team”.",
  designerTeamDescriptionHelp:
    "A short introduction to your team, its experience, or the way you work together.",
  designerTeamMemberNameHelp:
    "The name of this team member. Add a photo beside it so visitors can recognize the person.",
  designerSocialUrlHelp:
    "A link to this person’s social profile. Paste the complete profile address; the correct platform icon is added automatically.",
  designerTextContentHelp:
    "Write the extra information you want visitors to read. Short paragraphs and clear language are easiest to understand.",
  designerFaqTitleHelp:
    "The heading shown above your frequently asked questions.",
  designerFaqQuestionHelp:
    "Write a question in the same words a visitor would use.",
  designerFaqAnswerHelp:
    "Give a direct, useful answer. Keep the most important information first.",
  designerContactTitleHelp:
    "The heading that invites visitors to contact you, such as “Let’s talk about your project”.",
  designerContactDescriptionHelp:
    "A short note above the form that tells visitors what to ask or when they can expect a reply.",
  Retry: "Retry",
  "Signing out...": "Signing out...",
  "Checking availability...": "Checking availability...",
  "Loading page content": "Loading page content",
  "Loading...": "Loading...",
  Loaded: "Loaded",
  "Failed to load SEO settings.": "Failed to load SEO settings.",
  "Could not load SEO settings.": "Could not load SEO settings.",
  "Failed to load domains.": "Failed to load domains.",
  "Could not load site domains.": "Could not load site domains.",
  "Could not load domain status": "Could not load domain status",
  "Domain verification failed.": "Domain verification failed.",
  Domain: "Domain",
  Services: "Services",
  Photos: "Photos",
  "Failed to load this site.": "Failed to load this site.",
  "Failed to load the editor.": "Failed to load the editor.",
  "Could not find this site.": "Could not find this site.",
  "Refreshing sites": "Refreshing sites",
  "Open user menu": "Open user menu",
  "Open main menu": "Open main menu",
  "Image preview": "Image preview",
  "Delete image": "Delete image",
  "Coming soon...": "Coming soon...",
  English: "English",
  French: "French",
  "Invalid user name or password": "Invalid user name or password",
  "user already exists": "An account already exists for this email address",
  "Authentication required before upload.":
    "Authentication required before upload.",
  "Upload failed. Could not read server response.":
    "Upload failed. Could not read server response.",
  "Upload failed.": "Upload failed.",
  "Upload failed. Please retry.": "Upload failed. Please retry.",
  "Processing...": "Processing...",
  "Uploading...": "Uploading...",
  "Processing image...": "Processing image...",
  "Uploading image...": "Uploading image...",
};
